import { cva } from 'class-variance-authority';

import s from './Card.module.css';

export const cardVariants = cva(s.card, {
  defaultVariants: {
    background: 'default',
  },
  variants: {
    background: {
      default: s['card--background-default'],
      'gradient-accent': s['card--background-gradient-accent'],
      'gradient-accent-alt': s['card--background-gradient-accent-alt'],
      'gradient-danger': s['card--background-gradient-danger'],
      'gradient-success': s['card--background-gradient-success'],
    },
  },
});
